import Icon from 'vue-awesome/components/Icon'

Icon.register({
  label_off_rounded: {
    paths: [
      {
        d: 'M21.59 12.58a.99.99 0 000-1.16l-3.96-5.58C17.27 5.33 16.67 5 16 5H8.66l10.7 10.73 2.23-3.15zM2.72 4.72l.87.87C3.23 5.95 3 6.45 3 7v10c0 1.1.9 2 2 2h12l1.29 1.29a.996.996 0 101.41-1.41L4.14 3.31c-.38-.38-1.01-.39-1.4-.01a.99.99 0 00-.02 1.42z'
      }
    ],
    width: '24',
    height: '24'
  }
})
